// src/reducers/userReducer.js
import {
    GET_FEEDBACK_SUCCESS,
    GET_FEEDBACK_FAILURE,
  } from "../../actions/types";
  
  const initialState = {
    isLoading: false,
    response: null,
    error: null,
  };
  
  export const feedBackReducer = (state = initialState, action) => {
    switch (action.type) {
      case GET_FEEDBACK_SUCCESS:
        return {
          ...state,
          isLoading: false,
          response: action.payload,
          error: null,
        };
      case GET_FEEDBACK_FAILURE:
        return {
          ...state,
          isLoading: false,
          response: null,
          error: action.payload,
        };
      default:
        return state;
    }
  };
  